import type { HTMLAttributes } from 'react';
import css from './Kbd.module.css';

// No Mac o atalho é com ⌘ (os teclados do painel aceitam Ctrl ou ⌘).
const EH_MAC =
  typeof navigator !== 'undefined' && /Macintosh|Mac OS X|iPhone|iPad/.test(navigator.userAgent);

/** "Ctrl Enter" → "⌘ Enter" no Mac. */
export function textoDoAtalho(atalho: string, mac = EH_MAC): string {
  return mac ? atalho.replace(/\bCtrl\b/g, '⌘') : atalho;
}

const NOMES_ARIA: Record<string, string> = { ctrl: 'Control', esc: 'Escape', '⌘': 'Meta' };

/** "Ctrl Enter" → "Control+Enter" (formato de aria-keyshortcuts). */
export function atalhoParaAria(atalho: string): string {
  return atalho
    .split(/[\s+]+/)
    .filter(Boolean)
    .map((tecla) => NOMES_ARIA[tecla.toLowerCase()] ?? tecla)
    .join('+');
}

/**
 * Tecla escrita ("N", "Ctrl Enter"). Some em tela de toque, onde não há teclado. Dentro de botão
 * vai com `aria-hidden` (o botão leva `aria-keyshortcuts`); solta num texto, é lida.
 */
export function Kbd({
  children,
  className,
  ...resto
}: { children: string } & Omit<HTMLAttributes<HTMLElement>, 'children'>) {
  return (
    <kbd className={[css.kbd, className].filter(Boolean).join(' ')} {...resto}>
      {textoDoAtalho(children)}
    </kbd>
  );
}
